import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/zh-cn/downloads/checklists")({
  component: RouteLayout,
});

function RouteLayout() {
  return <Outlet />;
}
